import { ErrorLogComponent } from '@cian/error-log-component';
import { UiKitContextProvider } from '@cian/ui-kit/context';
import { FC } from 'react';
import { Provider } from 'react-redux';

import { IApplicationContext } from 'shared/types/applicationContext';
import { TReduxStore } from 'shared/types/redux';
import { ApplicationContext } from 'shared/utils/applicationContext';

import { selectLandingType } from '../../selectors/landingType/selectLandingType';
import { LoadableComponent } from '@loadable/component';
import { ELandingType } from '../../types/landingType';
import { ErrorLoadable } from '../joinOtaIndividual/Error/ErrorLoadable';
import * as React from 'react';
import { LoadableErrorBoundary } from '../../../packages/LoadableHelpers';
import { JoinOtaRootLoadable } from '../joinOtaIndividual/JoinOtaRoot/JoinOtaRootLoadable';
import { JoinOtaLegalShortLoadable } from '../joinOtaLegalShort/JoinOtaLegalShort/JoinOtaLegalShortLoadable';
import { ActivateInsuranceLoadable } from '../activateInsurance/ActivateInsurance/ActivateInsuranceLoadable';
import { useHeaderHeight } from '../../hooks';

export interface IApplicationProps {
  context: IApplicationContext;
  reduxStore: TReduxStore;
}

export const Application: FC<IApplicationProps> = ({ reduxStore, context }) => {
  const {
    logger,
    custom: { initialDeviceType },
  } = context;
  const state = reduxStore.getState();
  const landingType = selectLandingType(state);
  useHeaderHeight();
  let Component: LoadableComponent<unknown>;

  switch (landingType) {
    case ELandingType.JoinOtaCian:
      Component = JoinOtaRootLoadable;
      break;
    case ELandingType.JoinOtaLegalShort:
      Component = JoinOtaLegalShortLoadable;
      break;
    case ELandingType.ActivateInsurance:
      Component = ActivateInsuranceLoadable;
      break;
    default:
      Component = ErrorLoadable;
  }

  const handleRetryLoadContent = React.useCallback(() => {
    Component.load();
  }, [Component]);

  return (
    <ErrorLogComponent logger={logger}>
      <ApplicationContext.Provider value={context}>
        <UiKitContextProvider deviceType={initialDeviceType}>
          <Provider store={reduxStore}>
            <LoadableErrorBoundary logger={logger} onRetry={handleRetryLoadContent}>
              <Component />
            </LoadableErrorBoundary>
          </Provider>
        </UiKitContextProvider>
      </ApplicationContext.Provider>
    </ErrorLogComponent>
  );
};
